import { useEffect, useState } from 'react';
import useAxios from '../../../../hooks/useAxios';
import Constants from '../../../../Constants';

const useCommissionPayout = ({ selectedRange, selectedAccountExecutive, selectedCompanies }) => {
    const { postData, isLoading } = useAxios();
    const [monthlyData, setMonthlyData] = useState([]);
    const [totalCommission, setTotalCommission] = useState(0);

    useEffect(() => {
        const fetchCommissionPayout = async () => {
            try {
                const body = {
                    startDate: selectedRange?.startDate,
                    endDate: selectedRange?.endDate,
                    accountExecutives: selectedAccountExecutive ?? [],
                    companyIds: selectedCompanies ?? [],
                };
                const response = await postData(Constants.ApiUrl.super.dashboard.commissionPayout, body);
                if (response?.success) {
                    setMonthlyData(response.data?.monthlyData ?? []);
                    setTotalCommission(response.data?.totalCommission ?? 0);
                }
            } catch (e) {
                console.log('Error fetching commission payout', e);
                setMonthlyData([]);
                setTotalCommission(0);
            }
        };
        fetchCommissionPayout();
    }, [selectedRange, selectedAccountExecutive, selectedCompanies]);

    return { isLoading, monthlyData, totalCommission };
};

export default useCommissionPayout;
